import { ShiftResponseModel } from '@gtpl/shared-models/hrms';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UserRequestDto } from '../teams/dtos/user-request-dto';
import { ShiftReq } from './dto/shift-req.request';
import { ShiftDto } from './dto/shifts.dto';
import { ShiftRequest } from './dto/shifts.request';
import { ShiftService } from './shifts.service';

@ApiTags('shifts')
@Controller('shifts')
export class ShiftsController {
    constructor(
        private service: ShiftService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/createShift')
    async createShift(@Body() Dto: ShiftDto, isUpdate: boolean = false): Promise<ShiftResponseModel> {
        try {
            return await this.service.createShift(Dto, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ShiftResponseModel, error);
        }
    }

    @Post('/updateShift')
    async updateShift(@Body() Dto: ShiftDto, isUpdate: boolean = false): Promise<ShiftResponseModel> {
        try {
            return await this.service.createShift(Dto, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ShiftResponseModel, error)
        }
    }

    @Post('/getAllShiftActions')
    async getAllShiftActions(@Body() req?:UserRequestDto): Promise<ShiftResponseModel> {
        try {
            return await this.service.getAllShiftActions(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ShiftResponseModel, error)
        }
    }

    @Post('/getAllActiveShiftActions')
    async getAllActiveShiftActions(): Promise<ShiftResponseModel> {
        try {
            return await this.service.getAllActiveShiftActions();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ShiftResponseModel, error)
        }
    }

    @Post('/getShiftByShift')
    async getShiftByShift(@Body() shtReq: ShiftReq): Promise<ShiftResponseModel> {
        try {
            return await this.service.getShiftByShift(shtReq)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ShiftResponseModel, error)
        }
    }

    @Post('/activateOrDeactivateShift')
    async activateOrDeactivateShift(@Body() shtReq: ShiftRequest): Promise<ShiftResponseModel> {
        try {
            return await this.service.activateOrDeactivateShift(shtReq)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ShiftResponseModel, error)
        }
    }
}
